import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Vimeo from '@u-wave/react-vimeo';
import AtividadesService from '../services/AtividadesService';
import MensagemVideoService from '../services/MensagemVideoService';
import AgendaService from '../services/AgendaService';
import WeexModal from '../comps/weexModais/WeexModal';
import { animations } from 'react-animation';
import {useStore} from 'react-redux';

function Videos() {

    const i18n = useStore().getState().i18n; 

    const history = useHistory()
    let { codigo, codMensagemDeVideo, codigoAtividade } = useParams()
    const atividadesService = new AtividadesService()
    const mensagemVideoService = new MensagemVideoService()
    const agendaService = new AgendaService()
    const [video, setVideo] = useState()
    const [mensagemDeVideoUuid, setMensagemDeVideoUuid] = useState()
    const [assistido, setAssistido] = useState(true)
    const [finalizado, setFinalizado] = useState(false)
    const [bloquearBotao, setBloquearBotao] = useState(true)
    const [processando, setProcessando] = useState(false)
    const [erro, setErro] = useState(null)
    const [vimeoCarregado, setVimeoCarregado] = useState(false)
    
    useEffect(() => {
        if (!processando) {
            setProcessando(true)
            if(codigo){
                atividadesService.iniciarAtividade(codigo, codigoAtividade, (erro, atividade) => {
                    if (atividade) {
                        if(atividade.video.url.indexOf("youtube") != -1 || atividade.video.url.indexOf("youtu.be") != -1){
                            let regex = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/
                            let resultadoRegex = atividade.video.url.match(regex)
                            atividade.video.urlParseada = "https://www.youtube.com/embed/" + resultadoRegex[1] + "?autoplay=0&mute=0&controls=2&origin=" +  window.location.origin +
                                                        "&playsinline=1&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&enablejsapi=0&fs=1&autohide=1&widget_referrer=" + window.location.origin
                        }
                        setVideo(atividade.video)
                        setAssistido(atividade.dateFinished !== null)
                        setFinalizado(atividade.dateFinished !== null)
                        setBloquearBotao(atividade.dateFinished == null)

                        if (atividade.dateFinished !== null) {
                            agendaService.atualizarAgenda(codigo, codigoAtividade, "VIDEO", null, null, (erro, sucesso) => {
                                if (erro) {
                                    setErro({ 
                                        titulo: i18n.message("dinamica.erro.jaexecutada.titulo", "Erro ao exibir atividade já executada"), 
                                        mensagem: i18n.message("dinamica.erro.jaexecutada.mensagem", "Falha ao atualizar informações de atividade executadas, entre em contato com o suporte"), 
                                        voltarAgenda: true })
                                }
                            })
                        }
                    }
                    if (erro) {
                        if (erro.response && erro.response.data && erro.response.data.message) {
                            setErro({ 
                                titulo: i18n.message("dinamica.erro.iniciar.titulo", "Erro ao iniciar atividade"), 
                                mensagem: erro.response.data.message, 
                                voltarAgenda: true })
                        } else {
                            setErro({ 
                                titulo: i18n.message("dinamica.erro.iniciar.titulo", "Erro ao iniciar atividade"), 
                                mensagem: i18n.message("dinamica.erro.iniciar.mensagem", "Entre em contato com o suporte ou tente novamente mais tarde."), 
                                voltarAgenda: true })
                        }
                    }
                })
            }
            if(codMensagemDeVideo){
                mensagemVideoService.obterMensagemDeVideo((erro, atividade) => {
                    if (erro) {
                        if (erro.response && erro.response.data && erro.response.data.message) {
                            setErro({ 
                                titulo: i18n.message("mensagemvideo.erro.iniciar.titulo", "Erro ao iniciar mensagem de vídeo"), 
                                mensagem: erro.response.data.message, 
                                voltarAgenda: true })
                        } else {
                            setErro({ 
                                titulo: i18n.message("mensagemvideo.erro.iniciar.titulo", "Erro ao iniciar mensagem de vídeo"), 
                                mensagem: i18n.message("mensagemvideo.erro.iniciar.mensagem", "Entre em contato com o suporte ou tente novamente mais tarde."), 
                                voltarAgenda: true })
                        }
                    }
                    if (atividade) {
                        if(atividade[0].video.url.indexOf("youtube") != -1 || atividade[0].video.url.indexOf("youtu.be") != -1){
                            let regex = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/
                            let resultadoRegex = atividade[0].video.url.match(regex)
                            atividade[0].video.urlParseada = "https://www.youtube.com/embed/" + resultadoRegex[1] + "?autoplay=0&mute=0&controls=2&origin=" +  window.location.origin +
                                                        "&playsinline=1&showinfo=0&rel=0&iv_load_policy=3&modestbranding=1&enablejsapi=0&fs=1&autohide=1&widget_referrer=" + window.location.origin
                        }
                        setMensagemDeVideoUuid(atividade[0].uuid)
                        setVideo(atividade[0].video)
                    }
                });
            }
        }
    }, []);

    const callbackModal = () => {
        setErro(null)
        if (erro.voltarAgenda) {
            history.push("/atividades")
        }
    }

    const videoCarregado = () => {
        setVimeoCarregado(true)
    }

    const redirecionar = () => {
        if (assistido) {
            history.push("/atividades")
            return
        }
        setAssistido(true)
        history.push('/missionFinished/' + codigo + '/VIDEO/' + codigoAtividade)
        finalizar();
    }

    const finalizar = () => {
        setFinalizado(true)
        if (!assistido) {
            let corpo = {}
            atividadesService.finalizarAtividade(codigo, codigoAtividade, "VIDEO", corpo, (erro, atividade) => {
                if (atividade) {
                    return
                }
                if (erro) {
                    if (erro.response && erro.response.data && erro.response.data.message) {
                        setErro({ 
                            titulo: i18n.message("dinamica.erro.finalizar.titulo", "Erro ao finalizar atividade"), 
                            mensagem: erro.response.data.message, 
                            voltarAgenda: false })
                    } else {
                        setErro({ 
                            titulo: i18n.message("dinamica.erro.finalizar.titulo", "Erro ao finalizar atividade"), 
                            mensagem: i18n.message("dinamica.erro.finalizar.mensagem", "Entre em contato com o suporte ou tente novamente mais tarde."), 
                            voltarAgenda: false })
                    }
                }
            })
        }
    }

    const timeUpdate = (event) => {
        if (event) {
            if (!finalizado){
                if (event.percent > 0.8){
                    setBloquearBotao(false)
                    finalizar();
                }
            }
        }
    }

    const marcarComoVistoMensagem = () =>{

        mensagemVideoService.marcarComoVisto(mensagemDeVideoUuid,(erro, sucesso) => {
            if (erro) {
                if (erro.response && erro.response.data && erro.response.data.message) {
                    setErro({ 
                        titulo: i18n.message("mensagemvideo.erro.marcar.titulo", "Erro ao marcar mensagem de vídeo como visualizado"), 
                        mensagem: erro.response.data.message, 
                        voltarAgenda: false })
                } else {
                    setErro({ 
                        titulo: i18n.message("mensagemvideo.erro.marcar.titulo", "Erro ao marcar mensagem de vídeo como visualizado"), 
                        mensagem: i18n.message("mensagemvideo.erro.marcar.mensagem", "Entre em contato com o suporte ou tente novamente mais tarde."), 
                        voltarAgenda: false })
                }
            }
            if (sucesso) {
                history.push("/atividades")
            }
        });
    }

    const cssContainerVideo = {
        width: "100% !important",
        margin: "0px",
        height: (((window.innerWidth * 0.8) / 16) * 9)
    }

    const getVideo = () => {
        if(video.url.indexOf("vimeo") != -1){
            return (<Vimeo video={video.url} controls={true} onReady={videoCarregado} width={window.innerWidth * 0.8} height={((window.innerWidth * 0.8) / 16) * 9} 
                    style={{ animation: animations.popIn }} style={cssContainerVideo}
                    onTimeUpdate={timeUpdate}></Vimeo>)
        } else if(video.url.indexOf("video.weex.digital") != -1){
            return (<video controls>
                <source src={video.url} type="video/mp4"></source>
            </video>)
        } else {
            return (<div>
                <iframe style={cssContainerVideo} frameborder='0' allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope;' 
                            width="100%" height="100%" frameborder="0" allowfullscreen="allowfullscreen" mozallowfullscreen="mozallowfullscreen" 
                            msallowfullscreen="msallowfullscreen" oallowfullscreen="oallowfullscreen" webkitallowfullscreen="webkitallowfullscreen"
                            src={video.urlParseada} onLoad={videoCarregado}></iframe>
            </div>)
        }
    }

    const isVideoCarregado = () => {
        return (vimeoCarregado || (video && video.url.indexOf("video.weex.digital") != -1))
    }

    const botaoBloqueado = () => {
        return bloquearBotao && (video && video.url && video.url.indexOf("vimeo") != -1);
    }

    return (
        <div>
            {erro != null ? (
                <WeexModal callback={callbackModal} visivel={erro != null} titulo={erro.titulo} conteudo={erro.mensagem} />
            ) : null}
            {!isVideoCarregado() ? (
                <div className="aguarde aguarde__cinema">{i18n.message("video.carregando", "Aguarde, o video está sendo carregado...")}</div>
            ) : (null)}
            <div className="cinema">
                {video && video.url ? (
                    <div>
                        <div>
                            <div className="videoPlayerContainer">
                                {getVideo()}
                            </div>
                        </div>
                    </div>
                ) : (null)}
            </div>
            { isVideoCarregado() ? (
                <>
                {codigo ? (
                <button disabled={botaoBloqueado()}
                    className={botaoBloqueado() ? "weex-button__disabled weex-botao-confirmacao posicao-absolute-zindex" : "weex-button weex-botao-confirmacao posicao-absolute-zindex"}
                    onClick={redirecionar}
                >{assistido ? i18n.message("video.voltar", "Voltar") : i18n.message("video.entendi", "Entendi")}</button>
                ) : (
                    <button
                    className="weex-button weex-botao-confirmacao posicao-absolute-zindex"
                    onClick={marcarComoVistoMensagem}
                >{i18n.message("video.entendi", "Entendi")}</button>
                )}
                </>
            ) : (null)}
            <div className="footer-video"></div>
        </div>
    )
}
/**
 * codigo, codMensagemDeVideo
 */
export default Videos;